export const BLOCK_TYPE = {
  text: 'text',
  link: 'link',
} as const
